"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PenSlashSolid: function() {
        return PenSlashSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const PenSlashSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M17.7929 1.79288C19.0119 0.573925 20.9882 0.573924 22.2071 1.79288C23.4261 3.01183 23.4261 4.98814 22.2071 6.20709L20.9143 7.49996L16.5 3.08574L17.7929 1.79288Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M15.0858 4.49995L19.5 8.91417L14.9143 13.5L22.7071 21.2928C23.0976 21.6833 23.0976 22.3165 22.7071 22.707C22.3166 23.0975 21.6834 23.0975 21.2929 22.707L1.29289 2.70701C0.902369 2.31649 0.902369 1.68332 1.29289 1.2928C1.68342 0.902276 2.31658 0.902276 2.70711 1.2928L10.5 9.08574L15.0858 4.49995Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M3.46806 16.1177L7.68581 11.9L12.1 16.3142L7.88227 20.5319C6.98516 21.4291 5.8611 22.0655 4.63027 22.3732L2.24256 22.9701C1.90178 23.0553 1.54129 22.9555 1.29291 22.7071C1.04453 22.4587 0.944685 22.0982 1.02988 21.7574L1.62681 19.3697C1.93451 18.1389 2.57095 17.0148 3.46806 16.1177Z",
            fill: "currentColor"
        })
    ]
}), "PenSlashSolid");
const _default = PenSlashSolid;
